module.exports = __webpack_public_path__ + "static/media/img13_LV.4cbc245b.png";